import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'

export const EmployeeItem = React.memo(({
  item,
  activeItem,
  handleClickRow,
}) => {
  return (
    <Root
      active={ item._id === activeItem }
      onClick={ () => handleClickRow(item._id) }
    >
      <IDCol>{ item.emp_code }</IDCol>
      <CompanyCol>{ item.company }</CompanyCol>
      <LOBCol>{ item.lob }</LOBCol>
      <NameCol>{ item.name }</NameCol>
      <NicknameCol>{ item.nick_name }</NicknameCol>
      <PositionCol>{ item.position }</PositionCol>
    </Root>
  )
})

const Root = styled.div`
    min-height: 35px;
    height: auto;
    display: flex;
    align-items: center;
    padding: 0 24px;
    background: ${p => (p.active ? 'rgba(0, 0, 0, 0.075)' : '#FFFFFF')};
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #1A1A17;
    border-top: 1px solid #EAEAEA;
    cursor: pointer;

    :nth-child(1) {
        border: none;
    }

    :hover {
      background-color: rgba(0, 0, 0, 0.075);
    }
`

const IDCol = styled.div`
    flex: 1;
    padding: 0 8px;
    min-width: 0;
    word-wrap: break-word;

    svg {
      margin-left: 8px;
      font-size: 16px;
    }
`

const CompanyCol = styled(IDCol)`
    flex: 1;
`

const LOBCol = styled(IDCol)`
    flex: 1;
`

const NameCol = styled(IDCol)`
    flex: 2;
`

const NicknameCol = styled(IDCol)`
    flex: 1;
`

const PositionCol = styled(IDCol)`
    flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/data-table/employee-item.js